module.exports = __webpack_public_path__ + "product-pure-powder-capsule-11.jpg?6805e04428ac6317a395a4cf5bf4a054";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-11.jpg
// module id = 93
// module chunks = 0